$(document).ready(function () {

  $('[data-toggle="tooltip"]').tooltip();

  // Close any open menu accordions when window is resized below 768px
  $(window).resize(function () {
    if ($(window).width() < 768) {
      $('.sidebar .collapse').collapse('hide');
    }
  });

  // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
  $('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function (e) {
    if ($(window).width() > 768) {
      var e0 = e.originalEvent,
        delta = e0.wheelDelta || -e0.detail;
      this.scrollTop += (delta < 0 ? 1 : -1) * 30;
      e.preventDefault();
    }
  });

  // Scroll to top button appear
  $(document).on('scroll', function () {
    var scrollDistance = $(this).scrollTop();
    if (scrollDistance > 100) {
      $('.scroll-to-top').fadeIn();
    } else {
      $('.scroll-to-top').fadeOut();
    }
  });

  // Smooth scrolling using jQuery easing
  $(document).on('click', 'a.scroll-to-top', function (e) {
    var $anchor = $(this);
    $('html, body').stop().animate({
      scrollTop: ($($anchor.attr('href')).offset().top)
    }, 1000, 'easeInOutExpo');
    e.preventDefault();
  });
})

//Support dropdown menu
$('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
  if (!$(this).next().hasClass('show')) {
    $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
  }
  var $subMenu = $(this).next(".dropdown-menu");
  $subMenu.toggleClass('show');


  $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
    $('.dropdown-submenu .show').removeClass("show");
  });


  return false;
});

function collapseSideBarJS() {
  // console.log("collapseSideBarJS");
  $("body").toggleClass("sidebar-toggled");
  $(".sidebar").toggleClass("toggled");
  if ($(".sidebar").hasClass("toggled")) {
    $('.sidebar .collapse').collapse('hide');
  }
}

// handler envent hover on menu left of system Scontract
function collapseSideBarJSEventHover() {
  if ($("#accordionSidebar").hasClass("toggled")) {
    //exist
    $('[data-toggle="collapse"]').on('mouseenter', function () {
      $(this).parents('.nav-item').find('.collapse').collapse('show');
    });

    $('.overParentHover').on('mouseleave', function () {
      $(this).parents('.nav-item').find('.collapse').collapse('hide');
      $('.overParentHover').find('.collapse').collapse('hide');
    });
  } else {
    //off event
    $('[data-toggle="collapse"]').off('mouseenter');
    $('.overParentHover').off('mouseleave');
  }

  // Header sidebar thì ẩn mouseenter
  if ($("#accordionHeaderSidebar").hasClass("toggled")) {
    //off event
    $('[data-toggle="collapse"]').off('mouseenter');
  }
}

